module.exports = __webpack_public_path__ + "static/media/paulo.afce7faa.jpg";